import { sl } from './sl';

export const t = sl;
export type { Strings } from './sl';
